<template>
  <div class="container mt-4" dir="rtl">
    
    <!-- 1. لوحة التحكم -->
    <div class="card shadow-sm mb-4 border-top-dark no-print">
      <div class="card-header bg-white py-3">
        <h5 class="mb-0 text-dark fw-bold">
          <i class="fas fa-user-slash ms-2"></i> كشوف الغياب الكلي (الترمين معاً)
        </h5>
      </div>
      <div class="card-body">
        <div class="row g-3 align-items-end">
          <div class="col-md-4">
            <label class="form-label fw-bold">القطاع</label>
            <select v-model="filters.sector" class="form-select">
              <option value="">-- الكل --</option>
              <option value="1">قطاع العريش</option>
              <option value="2">قطاع بئر العبد</option>
            </select>
          </div>
          <div class="col-md-4">
            <button @click="fetchData" class="btn btn-dark w-100 fw-bold" :disabled="loading">
              <span v-if="loading" class="spinner-border spinner-border-sm ms-2"></span>
              تجهيز الكشوف
            </button>
          </div>
          <div class="col-md-4">
             <button @click="printReport" class="btn btn-outline-dark w-100" :disabled="reportData.length === 0">
               <i class="fas fa-print ms-2"></i> طباعة
             </button>
             <button @click="exportToPDF" class="btn btn-outline-dark w-100" :disabled="reportData.length === 0">
               <i class="fas fa-print ms-2"></i> dddddd
             </button>
          </div>
        </div>
      </div>
    </div>

    <!-- 2. التقرير -->
    <div id="printMe" v-if="reportData.length > 0">
      
      <div 
        v-for="(committee, index) in reportData" 
        :key="index" 
        class="committee-section"
        style="page-break-after: always;"
      >
        
        <!-- ترويسة -->
        <header class="mb-4 border-bottom pb-2">
          <div class="row text-center align-items-center">
            <div class="col-4 text-start">
              <h6 class="fw-bold mb-1">محافظة شمال سيناء</h6>
              <h6 class="fw-bold mb-0">لجنة النظام والمراقبة</h6>
            </div>
            <div class="col-4">
              <h3 class="fw-bold text-decoration-underline">كشف الطلاب (الغياب كلي)</h3>
              <h6 class="text-white badge bg-dark fs-6 border border-dark px-3">
                 غياب الترمين (دور ثان كامل الدرجة)
              </h6>
            </div>
            <div class="col-4 text-end">
              <h6 class="fw-bold mb-1">العام الدراسي: 2026</h6>
              <h6 class="fw-bold mb-0 text-muted">شئون الطلبة</h6>
            </div>
          </div>
          
          <div class="mt-3 bg-light p-2 border border-dark text-center rounded d-flex justify-content-center gap-4">
             <h4 class="m-0 fw-bold">مقر اللجنة: {{ committee.committee_name }}</h4>
             <h4 class="m-0 fw-bold text-primary">رقم اللجنة: ( {{ committee.committee_number }} )</h4>
          </div>
        </header>

        <!-- أ. إحصاء المواد (للمطبعة - تجهيز ورق كامل الدرجة) -->
        <div class="mb-4">
            <h6 class="fw-bold text-decoration-underline mb-2">أولاً: إحصاء أوراق الأسئلة المطلوبة (دور ثان):</h6>
            <div class="table-responsive">
                <table class="table table-bordered border-dark text-center table-sm mb-0 w-auto mx-auto">
                    <thead class="bg-secondary text-white">
                        <tr>
                            <th v-for="(count, subject) in committee.stats" :key="subject" class="px-3">{{ subject }}</th>
                            <th class="bg-dark">إجمالي الطلاب</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr class="fw-bold fs-5">
                            <td v-for="(count, subject) in committee.stats" :key="'val-'+subject">{{ count }}</td>
                            <td class="bg-light">{{ committee.students.length }}</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>

        <!-- ب. جدول الأسماء -->
        <h6 class="fw-bold text-decoration-underline mb-2">ثانياً: كشف أسماء الطلاب (غياب الترمين):</h6>
        <table class="table table-bordered border-dark text-center align-middle">
          <thead class="table-light" >
            <tr>
              <th width="5%">م</th>
              <th width="10%">الجلوس</th>
              <th width="30%" >اسم الطالب</th>
              <th width="25%">المدرسة</th>
              <th width="30%">الموقف (المواد)</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(student, sIndex) in committee.students" :key="sIndex">
              <td>{{ sIndex + 1 }}</td>
              <td class="fw-bold font-monospace fs-5">{{ student.seat_number }}</td>
              <td class="text-start pe-2 fw-bold">{{ student.name }}</td>
              <td class="small fw-bold text-primary">{{ student.school_name }}</td>
              
              <!-- تمييز الغياب الكلي -->
              <td class="fw-bold" :class="student.is_full ? 'bg-dark text-white' : 'bg-light text-danger'">
                 {{ student.subjects }}
              </td>
            </tr>
          </tbody>
        </table>

        <!-- تذييل -->
        <div class="mt-4 d-flex justify-content-around fw-bold break-avoid">
            <div>المراقب الأول</div>
            <div>رئيس اللجنة</div>
        </div>

        <div class="page-break"></div>

      </div>
    </div>
    
    <div v-else-if="searched" class="alert alert-info text-center mt-5 no-print">
        لا توجد حالات غياب كلي (ترمين) في هذا القطاع.
    </div>

  </div>
</template>

<script>
import api from '@/api/axios';
import printJS from 'print-js';
import html2pdf from 'html2pdf.js';
export default {
  name: "FullAbsenceReport",
  data() {
    return {
      loading: false,
      searched: false,
      filters: { sector: '' },
      reportData: []
    };
  },
  methods: {
    async fetchData() {
      this.loading = true;
      this.searched = true;
      try {
        // تأكد من المسار الصحيح في الباك اند
        const res = await api.get('/admin/full-absence-report', { params: this.filters });
        this.reportData = res.data;
      } catch (e) {
        alert("حدث خطأ في الاتصال"); 
      } finally {
        this.loading = false;
      }
    },
    printReport() {
    printJS({
      printable: 'printMe', // الـ ID الخاص بالعنصر
      type: 'html',


      css: [
        // '/css/adminlte.rtl.css',
        // 'assets/css/rtl.css',
        'https://cdn.jsdelivr.net/npm/bootstrap@5.1.3/dist/css/bootstrap.min.css'
        ], // ملف الستايل الخاص بالتقرير فقط
      scanStyles: false, // هذا يمنع وراثة ستايل الموقع (الميزة التي طلبتها)
      style: `
    @page { size: auto; margin: 10mm; } 
    body { direction: rtl !important;  } 
    .report-table { direction: rtl !important; }`,
      documentTitle: 'شهادة الطالب' // اسم الملف عند الحفظ
    });
  },
   exportToPDF() {
    // 1. تحديد العنصر المراد تحويله
    const element = document.getElementById('printMew'); // نفس الـ ID الخاص بالجدول
   element.classList.add('pdf-mode');
    // 2. ضبط الخيارات بدقة عالية
    const opt = {
      margin:       [10, 10, 10, 10], // الهوامش: [top, left, bottom, right] بالميليمتر
      filename:     `Student_Certificate_.pdf`, // اسم الملف ديناميكي
      
      image:        { type: 'jpeg', quality: 0.98 }, // جودة الصورة (أعلى شيء)
      
      html2canvas:  { 
        scale: 3,       // هذا أهم خيار: زيادة الرقم (2 أو 3) تجعل النص فائق الوضوح
        useCORS: true,  // للسماح بتحميل الصور الخارجية
        scrollY: 0      // لضمان بدء التصوير من أعلى العنصر
      },
      
      jsPDF:        { 
        unit: 'mm', 
        format: 'a4', 
        orientation: 'landscape' // اجعلها landscape لأن جدولك عريض
      }
    };

    // 3. التنفيذ
    html2pdf().from(element).set(opt).save().then(() => {
        // إزالة الكلاس ليعود الشكل الطبيعي للشاشة
        element.classList.remove('pdf-mode');
    });
  }
  }
};
</script>

<style scoped>
.border-top-dark { border-top: 4px solid #212529; }

@media print {
  @page { size: A4 portrait; margin: 10mm; }
  body * { visibility: hidden; }
  .no-print { display: none !important; }
  #printMe, #printMe * { visibility: visible; }
  #printMe { position: absolute; left: 0; top: 0; width: 100%; }
  
  .committee-section { page-break-after: always; }
  .break-avoid { page-break-inside: avoid; }
  
  .table-bordered th, .table-bordered td {
      border: 1px solid #000 !important;
      padding: 5px !important;
  }
  
  .bg-secondary { background-color: #6c757d !important; color: white !important; -webkit-print-color-adjust: exact; }
  .bg-dark { background-color: #000 !important; color: white !important; -webkit-print-color-adjust: exact; }
}

.pdf-mode .table-light td {
    font-size: 10px !important; /* خط أصغر ليتناسب مع PDF */
}
.pdf-mode * {
    font-weight: bold;
    font-size: 12px !important;
}
</style>